<template>
  <div>
    <smart-icon
      icon="icon-blood-pressure"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'HEALTHPARAMETERS'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-silverware-fork-knife"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'HEALTHYNUTRITION'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-pill"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'MEDICATIONS'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-heart-outline"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'MYHEART'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-smoking-off"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'SMOKECESSATION'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-run"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'STARTMOVING'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-meditation"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'STRESSMANAGEMENT'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-cholesterol-ldl"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'LOWERINGCHOLESTEROL'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-glucose"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'DIABETESMANAGEMENT'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-weight"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'HEALTHYWEIGHT'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-blood-pressure"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'LOWERINGBLOODPRESSURE'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="eva-people-outline"
      :size="$attrs.size || 20"
      :height="$attrs.size || 20"
      :width="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'MYSOCIALENVIRONMENT'"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import SmartIcon from "./SmartIcon";

/**
 * Component CategoryIcon.vue
 *
 * @module CategoryIcon
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/CategoryIcon.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "CategoryIcon",
  components: { SmartIcon },
  props: {
    categoryKey: {
      type: String,
      default: ''
    },
  },
};
</script>